// eslint-disable-next-line import/no-cycle
import { reservation as schemaReservation } from './schemas';
import apiClient from './apiClient';
import ReservationDataStore from '../../datastores/ReservationDataStore';
import DateHelper from '../../../core/helpers/DateHelper';
import { dateNumberToString } from '../../../presentation/reusables/Date/helpers';

class ReinforcementDataStoreGraphQL implements ReservationDataStore {
  client = apiClient();

  getMilisecondsLocalTime = () => new Date().getTimezoneOffset() * 60 * 1000;

  formatDates = (arrDates: any[]) => {
    const arrResource: any[] = [];
    arrDates.forEach((v: any) => {
      const datehelperhoursTablets = DateHelper.minutesToRange(
        v.hourStart,
        v.hourEnd,
        15
      );
      arrResource.push({
        id: v.date,
        name: dateNumberToString(v.date, 'medium'),
        hours: datehelperhoursTablets,
        durations: DateHelper.hoursToNumber(v.hours),
        hourStart: DateHelper.formatHour(
          v.hourStart + this.getMilisecondsLocalTime()
        ),
        hourEnd: DateHelper.formatHour(
          v.hourEnd + this.getMilisecondsLocalTime()
        )
      });
    });
    return arrResource;
  };

  async getCampusTablets() {
    try {
      const response = await this.client.query({
        query: schemaReservation.getCampusTablets
      });

      return response?.data?.resources.campus;
    } catch (error) {
      throw new Error('Error getCampusTablets');
    }
  }

  async getDatesTablet(idLibrary: number) {
    try {
      const responseTablets = await this.client.query({
        query: schemaReservation.getDatesTablet,
        variables: { idLibrary }
      });
      const dataTablets = responseTablets?.data?.resources.datesTablet;
      return this.formatDates(dataTablets);
    } catch (error) {
      throw new Error('Error getDatesTablets');
    }
  }

  async getDatesComputer(idLibrary: number) {
    try {
      const responseComputers = await this.client.query({
        query: schemaReservation.getDatesComputer,
        variables: { idLibrary }
      });

      const dataComputers = responseComputers?.data?.resources.datesComputer;
      return this.formatDates(dataComputers);
    } catch (error) {
      throw new Error('Error getDatesComputers');
    }
  }

  async subscribeResourceTablet(hours: any, hourStart: any, idLibrary: any) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReservation.subscribeResourceTablet,
        variables: { hours, hourStart, idLibrary }
      });
      return response?.data?.subscribeResourceTablet;
    } catch (error) {
      throw new Error('Error subscribeResourceTablet');
    }
  }

  async subscribeResourceComputer(hours: any, hourStart: any, idLibrary: any) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReservation.subscribeResourceComputer,
        variables: { hours, hourStart, idLibrary }
      });

      return response?.data?.subscribeResourceComputer;
    } catch (error) {
      throw new Error('Error subscribeResourceComputer');
    }
  }

  async getTabletDetail(id: string) {
    try {
      const response = await this.client.query({
        query: schemaReservation.getTabletDetail,
        variables: { id }
      });
      return response.data?.resources;
    } catch (error) {
      throw new Error('error resources');
    }
  }

  async cancelReservation(id: string) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReservation.cancelReservation,
        variables: { id }
      });
      return response.data?.cancelSubscriptionResourceTablet;
    } catch (error) {
      throw new Error('error resources');
    }
  }

  async getSubscribedsTablets() {
    try {
      const response = await this.client.query({
        query: schemaReservation.getSubscribedsTablets
      });
      return response?.data?.resources;
    } catch (error) {
      throw new Error('Error getSubscribedsTablets');
    }
  }

  async getStatusResource() {
    try {
      const response = await this.client.query({
        query: schemaReservation.getStatusResource
      });
      return response?.data?.resources;
    } catch (error) {
      throw new Error('Error getStatusResource');
    }
  }
}

export default ReinforcementDataStoreGraphQL;
